<template>
    <Sider v-if="showMenu" ref="side1" hide-trigger collapsible :collapsed-width="78" v-model="isCollapsed" on-collapse>
        <Menu active-name="1-2" theme="dark" width="auto" :class="menuitemClasses" :active-name="activeName"
              :open-names="openName">
            <Submenu :name="item.name" v-for="(item, index) in routerSide" :key="index">
                <template slot="title">
                    <div v-if="item.children && item.children.length">
                        <Icon :type="item.icon" class="icon-submenu"/>
                        <span>{{item.name}}</span>
                    </div>
                    <div v-else>
                        <router-link :to="item.path">
                            <Icon :type="item.icon"/>
                            <span>{{item.name}}</span>
                        </router-link>
                    </div>
                </template>
                <MenuItem :name="val.name" v-for="(val, key) in item.children" :key="key">
                    <router-link :to="val.path">
                        <span style="color: #fff">{{val.name}}</span>
                    </router-link>
                </MenuItem>
            </Submenu>
        </Menu>
    </Sider>
</template>

<script>
    import { hasSsoAdmin} from "@/assets/js/apiUse/publicApi";
    export default {
        name: "SideBar",
        props: {
            isCollapsed: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                showMenu: false,
                activeName: this.$route.name,
                openName: [this.$route.matched[0].name],
                routerSide: [
                    // 密码管理
                    {
                        path: '/main',
                        icon: 'ios-navigate',
                        name: '管理配置',
                        children: [
                            {
                                path: '/main/list',
                                name: '用户列表'
                            }, {
                                path: '/main/forgetpsd',
                                name: '忘记密码'
                            }
                        ]
                    }
                ]
            }
        },
        computed: {
            menuitemClasses() {
                return [
                    'menu-item',
                    this.isCollapsed ? 'collapsed-menu' : ''
                ]
            }
        },
        created() {
            // SSO管理员 可见 菜单
            hasSsoAdmin().then(res => {
                this.showMenu = true;
                if(res.code === 0 && res.data.data.isSsoAdmin) {
                   this.routerSide[0].children.unshift({
                       path: '/main/appManagement',
                       name: '应用管理'
                   })
                   this.routerSide[0].children.push({
                       path: '/main/pageSet',
                       name: '页面配置'
                   })
                }
            })
        },
        methods: {},
        watch: {
            isCollapsed(val) {
                // console.log(val,"val");
                if(val) {
                    this.$refs.side1.toggleCollapse();
                }
            }
        }
    }
</script>

<style scoped>
    .layout {
        border: 1px solid #d7dde4;
        background: #f5f7f9;
        position: relative;
        border-radius: 4px;
        overflow: hidden;
    }

    .layout-header-bar {
        background: #fff;
        box-shadow: 0 1px 1px rgba(0, 0, 0, .1);
    }

    .layout-logo-left {
        width: 90%;
        height: 30px;
        background: #5b6270;
        border-radius: 3px;
        margin: 15px auto;
    }

    .menu-icon {
        transition: all .3s;
    }

    .rotate-icon {
        transform: rotate(-90deg);
    }

    .menu-item span {
        display: inline-block;
        overflow: hidden;
        width: 60px;
        text-overflow: ellipsis;
        white-space: nowrap;
        vertical-align: bottom;
        transition: width .2s ease .2s;
    }
    .ivu-menu-item span{
        height: 49px;
        line-height: 49px;
        width: calc(100% - 20px);
    }

    .menu-item i {
        transform: translateX(0px);
        transition: font-size .2s ease, transform .2s ease;
        vertical-align: middle;
        font-size: 16px;
    }

    .collapsed-menu span {
        width: 0px;
        transition: width .2s ease;
    }

    .collapsed-menu i {
        transform: translateX(5px);
        transition: font-size .2s ease .2s, transform .2s ease .2s;
        vertical-align: middle;
        font-size: 22px;
    }
    .ivu-menu-vertical .ivu-menu-item{
        padding-top: 0px!important;
        padding-bottom: 0px!important;
    }
    .ivu-menu-submenu-title > div{
        display: flex;
        align-items: center;
        padding-left: 13px;
    }
    .icon-submenu{
        margin-right: 10px;
    }
</style>



// WEBPACK FOOTER //
// src/views/sideBar/index.vue